module.exports = __webpack_public_path__ + "img/j.c376942b.jpg";